import ParsingConstants from "../../parsing/parsing_constants.js";
import ParsingDfa4Table from "../../parsing/parsing_dfa_4table.js";
/**
 * DFA State machine states for parsing a comment.
 */
var COMMENT_STATE;
(function (COMMENT_STATE) {
    COMMENT_STATE[COMMENT_STATE["TERMINUS"] = 0] = "TERMINUS";
    COMMENT_STATE[COMMENT_STATE["ANY_BUT_STAR"] = 1] = "ANY_BUT_STAR";
    COMMENT_STATE[COMMENT_STATE["STAR_CASE"] = 2] = "STAR_CASE";
    COMMENT_STATE[COMMENT_STATE["SLASH_CASE"] = 3] = "SLASH_CASE";
})(COMMENT_STATE || (COMMENT_STATE = {}));
const COMMENT_PARSER_TERMINUS_FLAGS = (1 << COMMENT_STATE.SLASH_CASE);
const SLASH = ParsingConstants.SLASH;
const STAR = ParsingConstants.STAR;
const COMMENT_MINIMUM_LENGTH = 4;
const COMMENT_STAR_LENGTH = 2;
/**
 * DFA based parser for parsing a STEP comment.
 */
export default class StepCommentParser extends ParsingDfa4Table {
    /**
     * Construct the DFA
     */
    constructor() {
        super();
        /**
         * Match a STEP comment.
         *
         * @param input The input buffer to match against.
         * @param cursor The cursor to test the match against.
         * @param endCursor The end point to look at in the buffer.
         * @return {number | undefined} The end of the match.
         */
        this.match = (input, cursor, endCursor) => {
            if ((endCursor - cursor) < COMMENT_MINIMUM_LENGTH) {
                return;
            }
            if (input[cursor] !== SLASH || input[cursor + 1] !== STAR) {
                return;
            }
            return super.match(input, COMMENT_PARSER_TERMINUS_FLAGS, cursor + COMMENT_STAR_LENGTH, endCursor, COMMENT_STATE.ANY_BUT_STAR);
        };
        /* eslint-disable no-magic-numbers */
        this.range(COMMENT_STATE.ANY_BUT_STAR, 0, 255, COMMENT_STATE.ANY_BUT_STAR);
        this.set(COMMENT_STATE.ANY_BUT_STAR, "*", COMMENT_STATE.STAR_CASE);
        this.range(COMMENT_STATE.STAR_CASE, 0, 255, COMMENT_STATE.ANY_BUT_STAR);
        this.set(COMMENT_STATE.STAR_CASE, "*", COMMENT_STATE.STAR_CASE);
        this.set(COMMENT_STATE.STAR_CASE, "/", COMMENT_STATE.SLASH_CASE);
        /* eslint-enable no-magic-numbers */
        // Slash case is all terminus, to consume
    }
}
StepCommentParser.Instance = new StepCommentParser();
